module.exports = __webpack_public_path__ + "img/banker-gold_900.61456766.png";